import accountjournalsRoutes from './AccountJournalsModule/AccountJournalRoutes';
import billListingRoutes from './BillListing/BillListingRoutes';
import businessInsightRoutes from './BusinessInsights/BusinessInsightsRoutes';
import commonSettingRoutes from './CommonSettings/CommonSettingRoutes';
import consolidatedeInvoiceRoutes from './ConsolidatedEInvoice/ConsolidatedEInvoiceRoutes';
import generalSettingRoutes from './GeneralSettings/GeneralSettingRoutes';
import tableGridRoutes from './Home/TableGrid/TableGridRoute';
import outletSettingsRoutes from './OutletSettings/OutletSettingsRoutes';
import rentXTransferRoutes from './OutletSettings/RentXTransfer/RentXTransferRoutes';
import reservationRoutes from './Reservation/ReservationRoutes';
import stockMonitoringRoutes from './StockMonitoring/StockMonitoringRoutes';
import utilityRoutes from './Utility/UtilityRoutes';

const outletRoutes = [
	...tableGridRoutes,
	...reservationRoutes,
	...commonSettingRoutes,
	...generalSettingRoutes,
	...businessInsightRoutes,
	...outletSettingsRoutes,
	...stockMonitoringRoutes,
	...utilityRoutes,
	...billListingRoutes,
	...accountjournalsRoutes,
	...consolidatedeInvoiceRoutes,
	...rentXTransferRoutes
];

export default outletRoutes;
